import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './circle-loader.styl'

const CircleLoader = ({ size, extendClass, white, dark, inline }) => {
  const classes = cx(`${extendClass}`, {
    [styles.white]: white,
    [styles.dark]: dark,
    [styles.inline]: inline
  })

  return (
    <div
      className={`${classes} ${styles.loading}`}
      style={{ width: size / 2, height: size / 2 }}
    />
  )
}

CircleLoader.propTypes = {
  white: PropTypes.bool,
  dark: PropTypes.bool,
  inline: PropTypes.bool,
  size: PropTypes.number,
  extendClass: PropTypes.string
}

CircleLoader.defaultProps = {
  size: 50
}

export default CircleLoader
